import React, { useEffect } from "react";
import "./index.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllTracks } from "../../store/apis/tracks";
import { Col, Row } from "antd";
import TrackCard from "../../components/track-card";

function TracksPage() {
  const tracksState = useSelector((state) => state?.tracks?.tracks);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllTracks());
  }, []);

  const MostPopularTracks = () => {
    return (
      <div className="most-popular-tracks">
        <div className="most-popular-tracks-description">
          <h2> جميع المسارات </h2>
        </div>
        <Row className="tracks-cards-container">
          {tracksState &&
            tracksState?.docs?.map((item) => {
              return (
                <Col xs={24} sm={24} md={8} lg={6} xl={6} key={item._id}>
                  <a href={`/track/${item._id}`}>
                    <TrackCard track={item} />
                  </a>
                </Col>
              );
            })}
        </Row>
      </div>
    );
  };
  return <div className="tracks-page-container">{MostPopularTracks()}</div>;
}

export default TracksPage;
